// Copy of backend/src/lib/phone.ts (tested there) -- keep the two in sync.
/**
 * Normalize a typed-in phone number to E.164 ("+15095551234"), the format
 * Cognito's phone_number attribute and AWS End User Messaging both expect.
 * Bare 10-digit (or 1 + 10-digit) numbers are treated as US/Canada (NANP);
 * anything starting with "+" is taken as already international. Returns
 * null for anything that can't be a real number, so callers can 400 on it.
 */
export function normalizePhone(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed || /[a-z]/i.test(trimmed)) return null;

  const digits = trimmed.replace(/\D/g, "");

  if (trimmed.startsWith("+")) {
    // E.164 caps at 15 digits; 8 is a safe floor for real numbers.
    return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null;
  }

  const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (national.length !== 10) return null;
  // NANP area codes never start with 0 or 1.
  if (national[0] === "0" || national[0] === "1") return null;
  return `+1${national}`;
}
